module.exports = __webpack_public_path__ + "img/green-circle-table-5.d5f0b9b3.png";